import './QuickAccessViews.scss';
import { coreActions } from '@sonar-software/sonar-core';
import { getSonarObjectTypeFromId } from '@sonar-software/sonar-ts-lib';
import { QuickAccessViewButton } from './QuickAccessViewButton';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import { Button, Menu } from 'antd';
import { COPY_GENERIC, COPY_SPECIFIC, DATA_DICTIONARY_COPY, LINKS } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useMemo } from 'react';
import { SearchOptionGroup } from './DataDictionarySearch';
import { useAction, useBoolean, useCustomViews, useDataSecurityApps, useOnMount } from '@hooks';
const viewsGroup = {
    key: 'title',
    label: COPY_SPECIFIC.SAVED_VIEWS,
    type: 'group'
};
export const QuickAccessViews = ({ onSelect }) => {
    const [showAllViews, setShowAllViews] = useBoolean(false);
    const customViews = useCustomViews();
    const apps = useDataSecurityApps();
    const getViews = useAction(coreActions.requestGetCoreDataDictionaryViewReferences);
    useOnMount(() => {
        getViews({
            count: 50,
            ordering: 'LastUsed~d'
        });
    });
    const views = useMemo(() => {
        var _a;
        return [Object.assign(Object.assign({}, viewsGroup), { children: ((_a = (showAllViews ? customViews : customViews.slice(0, 10))) !== null && _a !== void 0 ? _a : [])
                    .map((view) => ({
                    group: SearchOptionGroup.View,
                    key: view.id,
                    label: React.createElement(QuickAccessViewButton, { viewId: view.id }),
                    value: view.id
                })) })];
    }, [showAllViews, customViews]);
    const handleOnClick = useCallback((info) => {
        var _a, _b, _c;
        const view = customViews.find((customView) => customView.id === Number(info.key));
        const sonarObjectType = (view === null || view === void 0 ? void 0 : view.sonarObjectTypeId) ?
            getSonarObjectTypeFromId(view.sonarObjectTypeId) : undefined;
        const displayName = (_a = view === null || view === void 0 ? void 0 : view.sonarObjectName) !== null && _a !== void 0 ? _a : (_b = apps.find((app) => app.applicationId === (view === null || view === void 0 ? void 0 : view.applicationId))) === null || _b === void 0 ? void 0 : _b.name;
        onSelect({
            applicationId: view === null || view === void 0 ? void 0 : view.applicationId,
            complianceCategory: view === null || view === void 0 ? void 0 : view.complianceCategory,
            displayName,
            sonarObjectId: view === null || view === void 0 ? void 0 : view.sonarObjectId,
            sonarObjectType,
            tagId: view === null || view === void 0 ? void 0 : view.tagId,
            viewId: Number(info.key),
            viewName: (_c = view === null || view === void 0 ? void 0 : view.name) !== null && _c !== void 0 ? _c : ''
        });
    }, [apps, customViews, onSelect]);
    return (React.createElement("div", null,
        React.createElement(Menu, { className: 'quick-access-menu', items: views, mode: 'inline', onClick: handleOnClick }),
        React.createElement(When, { condition: !customViews.length },
            React.createElement("div", { className: 'quick-access-views-placeholder' },
                React.createElement(SonarText, null, DATA_DICTIONARY_COPY.CUSTOMIZED_VIEWS_DISPLAYED_HERE),
                React.createElement(SonarText, null,
                    DATA_DICTIONARY_COPY.FOR_MORE_ON_SAVED_VIEWS,
                    React.createElement("a", { className: 'help-article-link', href: LINKS.DATA_DICTIONARY_HELP_ARTICLE, target: '_blank' }, DATA_DICTIONARY_COPY.DATA_DICTIONARY_HELP_ARTICLE)))),
        React.createElement(When, { condition: Number(customViews.length) > 10 },
            React.createElement(Button, { className: 'show-all', onClick: setShowAllViews.toggle, type: 'link' }, showAllViews ? COPY_GENERIC.SHOW_LESS : COPY_GENERIC.SHOW_ALL))));
};
